module.exports = __webpack_public_path__ + "img/vfi_logo.a97d984e.jpg";